import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';

interface UserStatProps {
  value: number;
  icon: string;
  label: string;
}

function UserStat({ value, icon, label }: UserStatProps) {
  return (
    <div>
      <Flex align="flex-end">
        <Text family="bold" size="16px">
          {value}
        </Text>
        <IconWrapper padding="4px">
          <Iconmoon className={icon} size="12px" />
        </IconWrapper>
      </Flex>
      <Text>{label}</Text>
    </div>
  );
}

export default UserStat;
